import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import useCliente from '../../../../hooks/useCliente';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { HeaderFormActions } from '../../../../shared/components/HeaderFormActions';
import Typography from '@mui/material/Typography';
import { Loader } from '../../../../shared/components/Loader';
import { Input } from '../../../../shared/components/Input';
import { InputCNPJCPF } from '../../../../shared/components/InputCNPJ';
import { InputIE } from '../../../../shared/components/InputIE';
import { InputDate } from '../../../../shared/components/InputDate';
import { InputCEP } from '../../../../shared/components/InputCEP';
import { InputTelephone } from '../../../../shared/components/InputTelephone';
import { InputPhone } from '../../../../shared/components/InputPhone';
import { InputSelect } from '../../../../shared/components/InputSelect';
import { useEffect, useState, useRef } from 'react';
import GrupoClienteController from '../../../../controllers/GrupoClienteController';
import { useLocation} from 'react-router-dom';
import { avaliarIe } from '../../../../shared/utils/inscricaoEstadual';

interface ItemGrupo {
  value: any;
  label: string;
}

export default function ClienteCadastrar() {
  const { id } = useParams();

  const clienteId = id ? parseInt(id, 10) : null;

  const opcoesListBox = [
    {value: 'S', label: 'Sim'},
    {value: 'N', label: 'Não'}
  ]

  const ref = useRef<HTMLButtonElement>(null);
  const [itemsGrupo, setItemsGrupo] = useState<ItemGrupo[]>([]);
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  const getGrupo = async (values: any): Promise<void> => {
    const DataRows: any = [];
    const Response = await GrupoClienteController.Listar(values);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: any) => {
        DataRows.push({
          value: item.grucli_id,
          label: item.grucli_descricao,
        });

        setItemsGrupo(DataRows);
      });
    }
  };

  useEffect(() => {
    ref?.current?.click();
    const initialValues = {
      Nome: '',
    };
    getGrupo(initialValues);
  }, []);

  const {
    loading,
    handleZipCode,
    handleSubmit,
    errors,
    handleBlur,
    touched,
    handleChange,
    values,
    backActions,
  } = useCliente(clienteId);

  // Aviso de IE para estado que NÃO é SP. Em SP quem reprova é o schema, e aí a
  // mensagem chega por errors.RgIe; aqui só sobra o caso "não posso afirmar que
  // está errado, mas está estranho".
  const { mensagem: avisoIe } = avaliarIe(
    values?.RgIe ?? '',
    values?.Estado ?? '',
    values?.CpfCnpj ?? ''
  );

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'CADASTRO DE CLIENTES'} />
      <Box className='p-3'>
        <form autoComplete='off' onSubmit={handleSubmit} name='customer-detail'>
          <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Box className='col-span-6'>
              <HeaderFormActions backActions={() => backActions()} duploClick={duploClick}/>
            </Box>

            <Typography className='col-span-8' variant='h6'>
              Dados Empresa/Cliente
            </Typography>
          </Box>

            <fieldset disabled={duploClick}>
            <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Input
              label='Código'
              className='col-span-2'
              name='Codigo'
              handleBlur={handleBlur}
              handleChange={handleChange}
              value={values.Codigo}
              disabled

            />
            <Input
              label='Nome'
              className='col-span-4'
              name='Nome'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.Nome ? errors.Nome : ''}
              hasError={!!(errors.Nome)}
              value={values?.Nome ?? ''}
            />
            <InputCNPJCPF
              label='CPF / CNPJ'
              className='col-span-2'
              name='CpfCnpj'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.CpfCnpj ? errors.CpfCnpj : ''}
              hasError={!!(errors.CpfCnpj)}
              value={values?.CpfCnpj ?? ''}
            />
            <InputIE
              label='RG / Inscrição Estadual'
              className='col-span-2'
              name='RgIe'
              handleBlur={handleBlur}
              handleChange={handleChange}
              // Fora de SP não dá para reprovar (cada estado tem regra própria e
              // eu não vou bloquear cadastro com regra não conferida), mas dá para
              // avisar. Passar o aviso como texto de apoio com hasError=false faz
              // ele aparecer em cinza, sem impedir o Salvar - o erro de SP vem
              // pelo schema e continua pintando de vermelho.
              error={errors.RgIe ? errors.RgIe : avisoIe}
              hasError={!!(errors.RgIe)}
              value={values?.RgIe ?? ''}
            />
            <InputDate
              label='Data de Nascimento'
              className='col-span-2'
              name='DataNascimento'
              handleBlur={handleBlur}
              handleChange={handleChange}
              hasError={!!(touched.DataNascimento && errors.DataNascimento)}
              value={values?.DataNascimento ?? ''}
            />
            <Input
              label='Razão Social'
              className='col-span-4'
              name='RazaoSocial'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.RazaoSocial ? errors.RazaoSocial: ''}
              hasError={!!(errors.RazaoSocial)}
              value={values?.RazaoSocial ?? ''}
            />
            <Input
              label='Nacionalidade'
              className='col-span-2'
              name='Nacionalidade'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.Nacionalidade && errors.Nacionalidade
                  ? errors.Nacionalidade
                  : ''
              }
              hasError={!!(touched.Nacionalidade && errors.Nacionalidade)}
              value={values?.Nacionalidade ?? ''}
            />
            <InputSelect
              label='Cliente Ativo'
              className='col-span-2'
              name='ClienteAtivo'
              items={opcoesListBox}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={errors.ClienteAtivo ? errors.ClienteAtivo : ''}
              helperText={errors.ClienteAtivo ? errors.ClienteAtivo : ''}
              value={values.ClienteAtivo}
              disabled={duploClick}              
            />
            <InputSelect
              label='Grupo Cliente'
              className='col-span-2'
              name='GrupoCliente'
              items={itemsGrupo}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={errors.GrupoCliente ? errors.GrupoCliente: ''}
              helperText={errors.GrupoCliente? errors.GrupoCliente: ''}
              value={values?.GrupoCliente ?? ''}
              disabled={duploClick}  
            />
            <InputSelect
              label='Fornecedor'
              className='col-span-2'
              name='Fornecedor'
              items={opcoesListBox}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={errors.Fornecedor ? errors.Fornecedor : ''}
              helperText={errors.Fornecedor ? errors.Fornecedor : ''}
              value={values.Fornecedor}
              disabled={duploClick}  
            />
            <InputSelect
              label='Transportadora'
              className='col-span-2'
              name='Transportadora'
              items={opcoesListBox}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={errors.Transportadora ? errors.Transportadora : ''}
              helperText={errors.Transportadora ? errors.Transportadora : ''}
              value={values.Transportadora}
              disabled={duploClick}  
            />
            <InputSelect
              label='Cliente'
              className='col-span-2'
              name='Cliente'
              items={opcoesListBox}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={errors.Cliente ? errors.Cliente : ''}
              helperText={errors.Cliente ? errors.Cliente : ''}
              value={values.Cliente}
              disabled={duploClick}  
            />
            <InputSelect
              label='Vendedor'
              className='col-span-2'
              name='Vendedor'
              items={opcoesListBox}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={touched.Vendedor && errors.Vendedor ? errors.Vendedor : ''}
              helperText={touched.Vendedor && errors.Vendedor ? errors.Vendedor : ''}
              value={values.Vendedor}
              disabled={duploClick}  
            />
            <InputSelect
              label='Bloqueado'
              className='col-span-2'
              name='Bloqueado'
              items={opcoesListBox}
              handleChange={(event) => {
                handleChange(event); // Para manter o controle do formulário
              }}
              error={touched.Bloqueado && errors.Bloqueado ? errors.Bloqueado : ''}
              helperText={touched.Bloqueado && errors.Bloqueado ? errors.Bloqueado : ''}
              value={values.Bloqueado}
              disabled={duploClick}  
            />
            <Typography className='col-span-8' variant='h6'>
              Dados Endereço
            </Typography>
            <InputCEP
              label='CEP'
              className='col-span-2'
              name='Cep'
              handleBlur={handleBlur}
              handleChange={handleZipCode}
              error={errors.Cep ? errors.Cep : ''}
              hasError={!!(errors.Cep)}
              value={values?.Cep ?? ''}
            />
            <Box className='col-span-6' />
            <Input
              label='Estado'
              className='col-span-1'
              name='Estado'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Estado && errors.Estado ? errors.Estado : ''}
              hasError={!!(touched.Estado && errors.Estado)}
              value={values?.Estado ?? ''}
            />
            <Input
              label='Cidade'
              className='col-span-3'
              name='Cidade'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Cidade && errors.Cidade ? errors.Cidade : ''}
              hasError={!!(touched.Cidade && errors.Cidade)}
              value={values?.Cidade ?? ''}
            />
            <Input
              label='Bairro'
              className='col-span-4'
              name='Bairro'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Bairro && errors.Bairro ? errors.Bairro : ''}
              hasError={!!(touched.Bairro && errors.Bairro)}
              value={values?.Bairro ?? ''}
            />
            <Input
              label='Endereço'
              className='col-span-4'
              name='Endereco'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.Endereco ? errors.Endereco : ''}
              hasError={!!(errors.Endereco)}
              value={values?.Endereco ?? ''}
            />
            <Input
              label='Numero'
              className='col-span-2'
              name='Numero'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Numero && errors.Numero ? errors.Numero : ''}
              hasError={!!(touched.Numero && errors.Numero)}
              value={values?.Numero ?? ''}
            />
            <Input
              label='Complemento'
              className='col-span-2'
              name='Complemento'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Complemento && errors.Complemento ? errors.Complemento: ''}
              hasError={!!(touched.Complemento && errors.Complemento)}
              value={values?.Complemento ?? ''}
            />
            <Typography className='col-span-8' variant='h6'>
              Dados de Contato
            </Typography>
            <InputTelephone
              label='Telefone'
              className='col-span-2'
              name='Telefone'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.Telefone ? errors.Telefone : ''}
              hasError={!!(errors.Telefone)}
              value={values?.Telefone ?? ''}
            />
            <InputPhone
              label='Celular'
              className='col-span-2'
              name='Celular'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.Celular ? errors.Celular : ''}
              hasError={!!(errors.Celular)}
              value={values?.Celular ?? ''}
            />
            <InputPhone
              label='Celular 2'
              className='col-span-2'
              name='Celular2'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.Celular2 && errors.Celular2 ? errors.Celular2 : ''}
              hasError={!!(touched.Celular2 && errors.Celular2)}
              value={values.Celular2}
            />
            <Input
              label='Email'
              className='col-span-2'
              name='Email'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={errors.Email ? errors.Email : ''}
              hasError={!!(errors.Email)}
              value={values?.Email ?? ''}
            />
          </Box>
          </fieldset>
        </form>
      </Box>
    </Loader>
  );
}
